module.exports = __webpack_public_path__ + "img/scripted-rest.977e8dad.svg";